import React from "react";
import DashboardPrincipal from "../../usuarios/DashboardPrincipal";
import DashboardLayout from "../../usuarios/components/DashboardLayout"; 

const Profesional = () => {
  // Ya no necesitas useEffect ni searchParams aquí
  // El AuthProvider ya se encargó de todo al cargar la App
  
  return (
    <DashboardLayout>
      <DashboardPrincipal />
    </DashboardLayout>
  );
};

export default Profesional;